import gql from 'graphql-tag';

export default gql`
  query GetAllContactUs ($searchTerm: String) {
    contactuses(
      orderBy: name_ASC
      where: {
        OR: [{ name_contains: $searchTerm }, { number_contains: $searchTerm }, { email_contains: $searchTerm }]
      }
    ) {
      id
      createdAt
      updatedAt
      name
      number
      email
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllContactUs.ts